module.exports = __webpack_public_path__ + "33df22db081afd404e1d84d987b5d47d.pdf";